import Vue from 'vue'
import request from './request'

const way = './graphql/ai/',
  mutation_way =  way + 'mutations/',
  query_way =  way + 'query/',
  environment = '/aiRequirements'
export default class AiRequirementsApi {
  async getParticipantAssessments(tenderId) {
    return await request({
      environment,
      type: 'query',
      name: 'getParticipantAssessments',
      variables: { tenderId },
      way: query_way,
      has_catch: true
    })
      .catch(error => Vue.prototype.$log_error(error.message))
  }

  async getRequirement(tenderId) {
    const result = await request({
      environment,
      type: 'query',
      name: 'getRequirements',
      variables: { tenderId },
      way: query_way,
      has_catch: true
    }).catch(error => Vue.prototype.$log_error(error.message))
    return this.parceResponceItems(result)
  }

  // mutations //////////////////////////////////////////////////////////////////////
  async fillRequirements(tenderId) {
    return await request({
      environment,
      type: 'mutation',
      name: 'fillRequirements',
      variables: { tenderId },
      way: mutation_way,
      has_catch: true,
      catch_callback: error => { throw error }
    })
      .catch(error => {
        Vue.prototype.$log_error(error.message)
        throw error
      })
  }

  async checkSupplierDocuments(model) {
    return await request({
      environment,
      type: 'mutation',
      name: 'checkSupplierDocuments',
      variables: { model },
      way: mutation_way,
      has_catch: true,
      catch_callback: error => { throw error }
    })
      .catch(error => {
        Vue.prototype.$log_error(error.message)
        throw error
      })
  }

  async editRequirement(model) {
    if (Array.isArray(model?.contents)) {
      model = this.joinContentsForRequest(model)
    }
    const result = await request({
      environment,
      type: 'mutation',
      name: 'editRequirement',
      variables: { model },
      way: mutation_way,
      has_catch: true,
      catch_callback: error => { throw error }
    })
      .catch(error => {
        Vue.prototype.$log_error(error.message)
        throw error
      })

    const parceItems = this.parceResponceItems({requirements: [result]})
    return parceItems.requirements?.[0]
  }

  async editRequirementActive(requirementId, isActive) {
    const model = {
      requirementId: requirementId,
      isActive: isActive,
      title: null,
    }
    const result = await request({
      environment,
      type: 'mutation',
      name: 'editRequirement',
      variables: { model },
      way: mutation_way,
      has_catch: true,
      catch_callback: error => { throw error }
    })
      .catch(error => {
        Vue.prototype.$log_error(error.message)
        throw error
      })

    const parceItems = this.parceResponceItems({requirements: [result]})
    return parceItems.requirements?.[0]
  }




  // services //////////////////////////////////////////////////////////////////////
  parceResponceItems(inputObject) {
    if (!inputObject || !Array.isArray(inputObject.requirements)) { return inputObject }

    return {
      ...inputObject,
      requirements: inputObject.requirements.map(item => ({
        ...item,
        contents: Array.isArray(item.contents)
          ? item.contents.map(content => {
            let label = ''
            let value = ''
            if (typeof content === 'string' && content.includes(':')) {
              const idx = content.indexOf(':')
              label = content.slice(0, idx).trim()
              value = content.slice(idx + 1).trim()
            } else {
              value = content
            }
            return { label, value }
          })
          : item.contents
      }))
    }
  }

  joinContentsForRequest(inputObject) {
    if (!inputObject || !Array.isArray(inputObject.contents)) { return inputObject }
    return {
      ...inputObject,
      contents: Array.isArray(inputObject.contents)
        ? inputObject.contents.map(content => {
          if (typeof content === 'object' && content !== null) {
            if (content.label && content.value) {
              return `${content.label}: ${content.value}`
            } else if (content.value) {
              return content.value
            } else {
              return ''
            }
          }
          return content
        })
        : inputObject.contents
    }
  }
}